// extracted by mini-css-extract-plugin
export var errorIcon = "_ne-1";
export var nameLogo = "_ne-0";